<template>
  <div>
    <!-- <h3>Update Dates and Hours</h3> -->

    <b-form @submit.prevent="submit()" class="form-horizontal">

      <b-form-group label="Start Date"
                    label-class="control-label">
        <datepicker v-model="form.startDate" class="bottom"
                    :inputClass="{ 'form-control': true }"
                    :typeable="true"
                    format="MM/dd/yyyy"></datepicker>
      </b-form-group>

      <b-form-group label="End Date"
                    label-class="control-label">
        <datepicker v-model="form.endDate" class="bottom"
                    :inputClass="{ 'form-control': true }"
                    :typeable="true"
                    format="MM/dd/yyyy"></datepicker>
      </b-form-group>

      <b-form-group label="Hours Worked" label-class="control-label opportunity-form-label">
          <b-form-input v-model="form.hoursWorked" type="number"></b-form-input>
        </b-form-group>

      <b-button type="submit" class="pull-right btn-primary">Save</b-button> 
    </b-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        startDate: null,
        endDate: null,
        hoursWorked: null
      }
    };
  },

  props: {
    studentOpportunity: {
      type: Object,
      required: true
    }
  },

  methods: {
    submit: function() {
      //this.$v.$touch();

      // only submit if the form is valid
      //if (!this.$v.$invalid) {
      this.save();
      // }
    },

    save: function() {
      // emit refresh signal
      this.$emit("submitted", this.form);
    },
    loadForm(item) {
      if (item) {
        this.form.startDate = this.studentOpportunity.startDate;
        this.form.endDate = this.studentOpportunity.endDate;
        this.form.hoursWorked = this.studentOpportunity.hoursWorked;
      }
    }
  },

  created() {
    if (this.studentOpportunity) {
      this.loadForm(this.studentOpportunity);
    }
  }
};
</script>

<style>
.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}
</style>
